// DEV-61. Страница /recovery — второй шаг РГ-06.
//
// Открывается по ссылке из письма: /recovery?request=<id>&token=<признак>.
// Признаки берутся из адреса, пароль проверяется теми же правилами, что при
// регистрации, а любой отказ сервера по ссылке показывается одним текстом —
// «ссылка недействительна или устарела» — без различия «истекла»/«использована».

import React, { FC, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import ButtonComponent from "../../components/buttons/ButtonComponent";
import RecoveryService from "../../services/RecoveryService";
import {
  RECOVERY_INVALID_LINK_MESSAGE,
  parseRecoveryParams,
  passwordError,
} from "../../utils/recovery";
import "../../components/loginform/styles.css";

const RecoveryPage: FC = () => {
  const [searchParams] = useSearchParams();
  const { requestId, token } = parseRecoveryParams(searchParams.toString());

  const [password, setPassword] = useState<string>("");
  const [confirmation, setConfirmation] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const linkUsable = requestId !== null && token !== null;

  const confirmRecovery = async (e: React.FormEvent) => {
    e.preventDefault();

    if (submitting || requestId === null || token === null) return;

    const rulesError = passwordError(password, confirmation);

    if (rulesError) {
      setError(rulesError);
      return;
    }

    setSubmitting(true);
    setError(null);

    try {
      await RecoveryService.confirm({ requestId, token, password });
      setSuccess(true);
    } catch (requestError: any) {
      setError(
        requestError?.response?.status === 400
          ? RECOVERY_INVALID_LINK_MESSAGE
          : "не удалось изменить пароль, попробуйте позже",
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (!linkUsable) {
    return (
      <div className="loginForm_conteiner" data-page="recovery">
        <div className="loginform_title">ВОССТАНОВЛЕНИЕ ДОСТУПА</div>
        <div className="recovery_answer" role="alert" data-recovery-error>
          {RECOVERY_INVALID_LINK_MESSAGE}
        </div>
        <Link to="/" className="recovery_link">
          Запросить новую ссылку
        </Link>
      </div>
    );
  }

  if (success) {
    return (
      <div className="loginForm_conteiner" data-page="recovery">
        <div className="loginform_title">ВОССТАНОВЛЕНИЕ ДОСТУПА</div>
        <div className="recovery_answer" role="status" data-recovery-success>
          пароль изменён. Войдите с новым паролем.
        </div>
        <Link to="/" className="recovery_link">
          Перейти ко входу
        </Link>
      </div>
    );
  }

  return (
    <div className="loginForm_conteiner" data-page="recovery">
      <div className="loginform_title">НОВЫЙ ПАРОЛЬ</div>

      <form onSubmit={confirmRecovery}>
        <div className="loginForm_form">
          <label htmlFor="recovery-password">Новый пароль:</label>
          <input
            className="loginForm_input"
            id="recovery-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            maxLength={20}
          />
        </div>

        <div className="loginForm_form">
          <label htmlFor="recovery-password-confirm">Повторите пароль:</label>
          <input
            className="loginForm_input"
            id="recovery-password-confirm"
            type="password"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            required
            minLength={8}
            maxLength={20}
          />
        </div>

        <div className="loginForm_btns">
          <ButtonComponent title="Сохранить пароль" size="100%" />
        </div>
      </form>

      {error ? (
        <div className="Error_message" role="alert" data-recovery-error>
          <div className="Error_message_title">Ошибка:</div>
          {error}
        </div>
      ) : null}

      {error === RECOVERY_INVALID_LINK_MESSAGE ? (
        <Link to="/" className="recovery_link">
          Запросить новую ссылку
        </Link>
      ) : null}
    </div>
  );
};

export default RecoveryPage;
